























































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Form, Message, MessageBox } from 'element-ui'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import { LoanResponse, LoanState, LoanCycleUnit, LoanRateType, loanReviewWequest, LoanReviewResponse } from '@/api/model/loan'
import $Api from '@api'
import { translate, DateTime } from '@/utils/filters'
import { finalize, startWith } from 'rxjs/operators'

const loanStateOption: { label: string; value: LoanState }[] = [
    {
        label: translate('loan.tableData.loanState.init'),
        value: LoanState.INIT
    },
    {
        label: translate('loan.tableData.loanState.lending'),
        value: LoanState.LENDING
    },
    {
        label: translate('loan.tableData.loanState.finish'),
        value: LoanState.FINISH
    },
    {
        label: translate('loan.tableData.loanState.writeoff'),
        value: LoanState.WRITEOFF
    },
    {
        label: translate('loan.tableData.loanState.cancel'),
        value: LoanState.CANCEL
    },
    {
        label: translate('loan.tableData.loanState.fail'),
        value: LoanState.FAIL
    },
    {
        label: translate('loan.tableData.loanState.refuse'),
        value: LoanState.REFUSE
    },
    {
        label: translate('loan.tableData.loanState.transaction'),
        value: LoanState.TRANSACTION
    }
]

@Component({
    components: {
        SearchForm,
        TableForm
    },
    filters: {
        transformLoanState(state: LoanState) {
            const item = loanStateOption.find(option => option.value === state)
            if (item) {
                return item.label
            }
            return state
        }
    }
})
export default class CreditCheckComponent extends Vue {
    tableData: LoanResponse[] = []
    shouldTableLoading = false
    total = 0
    releaseTime = null
    reviewTime = null
    searchForm: { [key: string]: any } = {
        current: 1,
        size: 10,
        cameraIdStr: null,
        state: null,
        startReleaseTime: null,
        endReleaseTime: null,
        startReviewTime: null,
        endReviewTime: null
    }
    loanStateOption = loanStateOption
    loanState = LoanState
    defaultTime = ['00:00:00', '23:59:59']

    checkingLoading = {
        approve: false,
        reject: false
    }
    reviewMap = {
        approve: true,
        reject: false
    }
    reviewMessageMap = {
        approve: translate('credit.check.dialog.approved'),
        reject: translate('credit.check.dialog.rejected')
    }
    checkingDialogVisible = false
    checkingRemark = ''
    checkResultDialogVisible = false

    curRecord = {} as LoanResponse

    multipleSelection: LoanResponse[] = []

    handleSelectionChange(records: LoanResponse[]): void {
        this.multipleSelection = records
    }

    created(): void {
        this.getData()
    }

    getData(pageQuery?: object): void {
        if (pageQuery) {
            Object.assign(this.searchForm, pageQuery)
        }
        this.shouldTableLoading = true
        $Api.loanService
            .queryLoanPage(this.searchForm)
            .pipe(
                finalize(() => {
                    this.shouldTableLoading = false
                })
            )
            .subscribe(data => {
                this.tableData = data.records
                this.total = data.total
            })
    }

    onSearchSubmit(): void {
        this.searchForm.current = 1
        this.getData()
    }

    onFormReset(): void {
        // The resetFields method (from SearchForm.vue) does not take effect on datePicker, need to reset manually
        this.releaseTime = null
        this.reviewTime = null
    }

    onCheckingSubmit(action: string): void {
        const remark = this.checkingRemark
        const review = this.reviewMap[action]
        const lids = this.multipleSelection.map(item => { return item.lid }).join(',')
        $Api.loanService
            .loanReview({ lids, remark, review })
            .pipe(
                finalize(() => {
                    this.checkingLoading[action] = false
                })
            )
            .subscribe(
                data => {
                    if (data) {
                        this.checkingDialogVisible = false
                        if (data.success) {
                            Message.success(data.msg)
                        } else {
                            Message.error({ message: data.msg, duration: 7000 })
                        }
                        this.getData()
                    }
                },
                error => {
                    this.$notify.error(error.message)
                }
            )
    }

    viewCheckResult(row: LoanResponse): void {
        this.curRecord = row
        this.checkResultDialogVisible = true
    }

    get canReview() {
        if (this.multipleSelection.length < 1) {
            return false
        }
        const initCount = this.multipleSelection.filter((item) => { return item.state === LoanState.INIT }).length
        if (initCount < this.multipleSelection.length) {
            return false
        }
        return true
    }

    batchReview(): void {
        this.checkingDialogVisible = true
    }

    @Watch('releaseTime')
    onReleaseTimeChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.startReleaseTime = null
            this.searchForm.endReleaseTime = null
        } else {
            const [startReleaseTime, endReleaseTime] = date
            this.searchForm.startReleaseTime = startReleaseTime.getTime()
            this.searchForm.endReleaseTime = endReleaseTime.getTime()
        }
    }

    @Watch('reviewTime')
    onReviewTimeChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.startReviewTime = null
            this.searchForm.endReviewTime = null
        } else {
            const [startReviewTime, endReviewTime] = date
            this.searchForm.startReviewTime = startReviewTime.getTime()
            this.searchForm.endReviewTime = endReviewTime.getTime()
        }
    }

    dateTime(time) {
        if (time) return DateTime(time)
        return ''
    }

    get country() {
        return (this.$store.state.auth.authInfo || {}).country
    }
}
